import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { ChevronLeft, ChevronRight, Search } from 'lucide-react';

export const StudentSearchContent = ({
  students,
  setActiveSection,
  setSelectedStudent,
  setShowStudentModal
}) => {
  const [localSearch, setLocalSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  
  const searchResults = students.filter(s => {
    const matchesSearch = !localSearch || 
      s.name?.toLowerCase().includes(localSearch.toLowerCase()) ||
      s.email?.toLowerCase().includes(localSearch.toLowerCase()) ||
      s.phone?.includes(localSearch);
    
    let matchesFilter = true;
    if (filterStatus === 'loggedIn') matchesFilter = !!s.last_login;
    if (filterStatus === 'neverLoggedIn') matchesFilter = !s.last_login;
    if (filterStatus === 'noAgreement') matchesFilter = !s.agreements_accepted;
    
    return matchesSearch && matchesFilter;
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4 mb-6">
        <Button variant="ghost" onClick={() => setActiveSection('student-hub')}>
          <ChevronLeft className="w-4 h-4 mr-2" />
          Geri
        </Button>
      </div>

      {/* Arama ve Filtreler */}
      <Card className="border-0 shadow-lg">
        <CardContent className="p-6">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <Input
                placeholder="İsim, e-posta veya telefon ile ara..."
                value={localSearch}
                onChange={(e) => setLocalSearch(e.target.value)}
                className="pl-10 h-12 text-lg"
              />
            </div>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="h-12 px-4 border rounded-lg bg-white"
            >
              <option value="all">Tüm Öğrenciler</option>
              <option value="loggedIn">Giriş Yapmış</option>
              <option value="neverLoggedIn">Hiç Giriş Yapmamış</option>
              <option value="noAgreement">Sözleşme Bekleyen</option>
            </select>
          </div>
        </CardContent>
      </Card>

      {/* Sonuçlar */}
      <Card className="border-0 shadow-lg">
        <CardHeader>
          <CardTitle>
            Arama Sonuçları 
            <span className="text-gray-500 font-normal ml-2">({searchResults.length} öğrenci)</span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2 max-h-[500px] overflow-y-auto">
            {searchResults.map(student => (
              <div 
                key={student.id}
                className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  setSelectedStudent(student);
                  setShowStudentModal(true);
                }}
              >
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold">
                    {student.name?.charAt(0)}
                  </div>
                  <div>
                    <p className="font-semibold">{student.name}</p>
                    <p className="text-sm text-gray-500">{student.email}</p>
                    {student.phone && <p className="text-sm text-gray-400">{student.phone}</p>}
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-right">
                    <p className="font-medium">{student.miles || 0} Mil</p>
                    <p className="text-xs text-gray-500">
                      {student.last_login 
                        ? `Son: ${new Date(student.last_login).toLocaleDateString('tr-TR')}` 
                        : 'Hiç giriş yapmadı'}
                    </p>
                  </div>
                  <div className="flex gap-1">
                    {student.agreements_accepted ? (
                      <span className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded">Sözleşme ✓</span>
                    ) : (
                      <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs rounded">Sözleşme ✗</span>
                    )}
                  </div>
                  <ChevronRight className="w-5 h-5 text-gray-400" />
                </div>
              </div>
            ))}
            {searchResults.length === 0 && (
              <div className="text-center py-12 text-gray-500">
                <Search className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                <p>Aramanıza uygun öğrenci bulunamadı</p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StudentSearchContent;
